import { Navigate } from "react-router-dom"
import { useContext, useEffect, useRef, useState } from "react"
import { AppContext } from "../../context/AppContext"

export default function ProtectedRoute({ children }) {
  const { user, loginUser, logoutUser } = useContext(AppContext)
  const [checking, setChecking] = useState(true)
  const requestedRef = useRef(false)

  useEffect(() => {
    if (user.isLoggedIn) {
      setChecking(false)
      return
    }

    if (requestedRef.current) return
    requestedRef.current = true

    const verifySession = async () => {
      try {
        const res = await fetch("/sistema/get-user-info/", {
          method: "GET",
          credentials: "include",
        })

        if (res.ok) {
          const data = await res.json()

          loginUser({
            email: data.email,
            username: data.username,
            isSuperuser: data.is_superuser,
            isAdmin: data.is_admin,
            isVendedor: data.is_vendedor,
          })
        } else {
          logoutUser()
        }
      } catch {
        logoutUser()
      } finally {
        setChecking(false)
      }
    }

    verifySession()
  }, [user.isLoggedIn, loginUser, logoutUser])

  if (checking) return null

  if (!user.isLoggedIn) {
    return <Navigate to="/login" replace />
  }

  return children
}